module.exports = __webpack_public_path__ + "img/about-building.121f95f6.jpg";